import { render, staticRenderFns } from "./ViewVideo.vue?vue&type=template&id=0aa55865"
import script from "./ViewVideo.vue?vue&type=script&lang=js"
export * from "./ViewVideo.vue?vue&type=script&lang=js"
import style0 from "./ViewVideo.vue?vue&type=style&index=0&id=0aa55865&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports